import type { ImgHTMLAttributes } from "react";

// PictureSource matchar formen som `vite-imagetools` returnerar med
// `?as=picture` — `{ sources: { avif: srcset, webp: srcset }, img: {...} }`.
export type PictureData = {
  sources: Record<string, string>;
  img: { src: string; w: number; h: number };
};

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  /** Importera bilden med `?as=picture&format=avif;webp;jpg` och skicka in resultatet här. */
  data: PictureData;
  /** Default order: avif → webp → fallback. */
  formats?: Array<"avif" | "webp">;
};

/**
 * Renderar ett `<picture>` med AVIF + WebP `<source>` + `<img>`-fallback.
 * Använd för hero-bilder och tyngre bilder där formatvinsten lönar sig.
 */
export function Picture({
  data,
  formats = ["avif", "webp"],
  alt = "",
  loading = "lazy",
  decoding = "async",
  ...imgProps
}: Props) {
  return (
    <picture>
      {formats.map((fmt) =>
        data.sources[fmt] ? (
          <source key={fmt} type={`image/${fmt}`} srcSet={data.sources[fmt]} />
        ) : null,
      )}
      <img
        src={data.img.src}
        width={data.img.w}
        height={data.img.h}
        alt={alt}
        loading={loading}
        decoding={decoding}
        {...imgProps}
      />
    </picture>
  );
}
